import { supabase } from '../../config/supabase';

export const getCustomerConversations = async (companyId, jobId) => {
    const { data, error } = await supabase
        .from('customer_conversations')
        .select('*')
        .eq('company_id', companyId)
        .eq('job_id', jobId)
        .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
};

export const getCustomerConversationCustomerStats = async (companyId, customerName) => {
    if (!companyId || !customerName) {
        return {
            totalJobs: 0,
            activeJobs: 0,
            completedJobs: 0,
        };
    }

    const { data, error } = await supabase
        .from('jobs')
        .select('id, main_status')
        .eq('company_id', companyId)
        .eq('customer_name', customerName)
        .eq('deleted', false);

    if (error) throw error;

    const jobs = data || [];
    const completedJobs = jobs.filter(job => job.main_status === 'completed').length;

    return {
        totalJobs: jobs.length,
        activeJobs: Math.max(jobs.length - completedJobs, 0),
        completedJobs,
    };
};

export const subscribeToCustomerConversations = (companyId, jobId, callback) => {
    return supabase
        .channel(`customer-conversations-${jobId}`)
        .on(
            'postgres_changes',
            {
                event: '*',
                schema: 'public',
                table: 'customer_conversations',
                filter: `company_id=eq.${companyId}`,
            },
            (payload) => {
                if (payload.new?.job_id === jobId || payload.old?.job_id === jobId) {
                    callback(payload);
                }
            }
        )
        .subscribe();
};
